import { useEffect, useRef } from "react";
import '../../styles/EventsStyles/PrivacyModal.css';
import PrivacyNoticeContent from "./PrivacyNoticeContent";

interface PrivacyModalProps {
  onClose: () => void;
}

// The privacy notice over the registration form, so the form keeps what's been typed.
// The same notice has its own page at /events/privacy.
export default function PrivacyModal({ onClose }: PrivacyModalProps) {
  const closeRef = useRef<HTMLButtonElement>(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  // Focus the close button once on open, and close on Escape
  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onCloseRef.current(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="ev-modal-backdrop" onClick={onClose}>
      <div
        className="ev-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="privacy-title"
        onClick={e => e.stopPropagation()}
      >
        <div className="ev-modal-head">
          <h2 id="privacy-title">Privacy notice</h2>
          <button ref={closeRef} type="button" className="ev-modal-close" onClick={onClose} aria-label="Close privacy notice">×</button>
        </div>
        <PrivacyNoticeContent />
        {/* A new tab, so the half-filled form stays as it is */}
        <p className="ev-modal-foot">
          <a href="/events/privacy" target="_blank" rel="noopener">Open the privacy notice as a page ↗</a>
        </p>
      </div>
    </div>
  );
}
